"use strict";
/**
 * Shared field allowlists for row mutations.
 *
 * Security: only known keys reach the wire.
 * Safety: if the client intended a mutation but every non-identity field
 * was stripped, fail loudly — do not POST a silent no-op (geo / place bug class).
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.fieldAllowlistToastText = exports.pickAllowedFieldsOrThrow = exports.pickAllowedFields = exports.FieldAllowlistError = exports.ROW_IDENTITY_KEYS = void 0;
/** Keys that identify a row but do not constitute an update by themselves. */
exports.ROW_IDENTITY_KEYS = ['ID', 'id'];
var FieldAllowlistError = /** @class */ (function (_super) {
    __extends(FieldAllowlistError, _super);
    function FieldAllowlistError(message, opts) {
        var _this = _super.call(this, message) || this;
        _this.name = 'FieldAllowlistError';
        _this.channel = opts.channel;
        _this.droppedKeys = opts.droppedKeys;
        _this.keptKeys = opts.keptKeys;
        Object.setPrototypeOf(_this, FieldAllowlistError.prototype);
        return _this;
    }
    return FieldAllowlistError;
}(Error));
exports.FieldAllowlistError = FieldAllowlistError;
function pickAllowedFields(source, allowedKeys) {
    if (!source || typeof source !== 'object') {
        return null;
    }
    if (!allowedKeys || typeof allowedKeys.length !== 'number') {
        var droppedKeys_1 = Object.keys(source);
        return {
            clean: {},
            droppedKeys: droppedKeys_1,
            keptKeys: [],
            mutationKeys: [],
        };
    }
    var allowed = new Set(allowedKeys);
    var clean = {};
    var droppedKeys = [];
    for (var _i = 0, _a = Object.keys(source); _i < _a.length; _i++) {
        var key = _a[_i];
        if (allowed.has(key)) {
            clean[key] = source[key];
        }
        else {
            droppedKeys.push(key);
        }
    }
    // Preserve allowlist order for stable payloads (optional nicety)
    var ordered = {};
    for (var i = 0; i < allowedKeys.length; i++) {
        var key = allowedKeys[i];
        if (Object.prototype.hasOwnProperty.call(clean, key)) {
            ordered[key] = clean[key];
        }
    }
    var keptKeys = Object.keys(ordered);
    var identity = new Set(exports.ROW_IDENTITY_KEYS);
    var mutationKeys = keptKeys.filter(function (k) { return !identity.has(k); });
    return {
        clean: ordered,
        droppedKeys: droppedKeys,
        keptKeys: keptKeys,
        mutationKeys: mutationKeys,
    };
}
exports.pickAllowedFields = pickAllowedFields;
/**
 * Pick allowed fields and throw if the source looked like a mutation but
 * nothing non-identity remains (all real fields stripped or none allowed).
 */
function pickAllowedFieldsOrThrow(source, allowedKeys, channel) {
    if (source === null || source === undefined) {
        return source;
    }
    var result = pickAllowedFields(source, allowedKeys);
    if (!result) {
        return source;
    }
    var sourceKeys = Object.keys(source);
    var identity = new Set(exports.ROW_IDENTITY_KEYS);
    var sourceHadMutationIntent = sourceKeys.some(function (k) { return !identity.has(k); });
    if (sourceHadMutationIntent && result.mutationKeys.length === 0) {
        var dropped = result.droppedKeys.length
            ? result.droppedKeys.join(', ')
            : '(none on allowlist)';
        throw new FieldAllowlistError("Save blocked: no allowed fields for ".concat(channel, ". Dropped: ").concat(dropped, ". Use a dedicated API for this action."), {
            channel: channel,
            droppedKeys: result.droppedKeys,
            keptKeys: result.keptKeys,
        });
    }
    return result.clean;
}
exports.pickAllowedFieldsOrThrow = pickAllowedFieldsOrThrow;
/** Human-readable toast body for FieldAllowlistError. */
function fieldAllowlistToastText(err) {
    var dropped = err.droppedKeys.length > 0 ? err.droppedKeys.slice(0, 8).join(', ') : 'unknown fields';
    var more = err.droppedKeys.length > 8 ? '…' : '';
    return "Save blocked (".concat(err.channel, "): fields not allowed \u2014 ").concat(dropped).concat(more);
}
exports.fieldAllowlistToastText = fieldAllowlistToastText;
